/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_oer_information_video_description_production40 = /** @type {(inputs: {}) => string} */ () => {
	return `Production`
};

const fr_oer_information_video_description_production40 = /** @type {(inputs: {}) => string} */ () => {
	return `Production`
};

const de_oer_information_video_description_production40 = /** @type {(inputs: {}) => string} */ () => {
	return `Produktion`
};

const es_oer_information_video_description_production40 = /** @type {(inputs: {}) => string} */ () => {
	return `Producción`
};

const it_oer_information_video_description_production40 = /** @type {(inputs: {}) => string} */ () => {
	return `Produzione`
};

const ar_oer_information_video_description_production40 = /** @type {(inputs: {}) => string} */ () => {
	return `إنتاج`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const oer_information_video_description_production40 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.oer_information_video_description_production40(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("oer_information_video_description_production40", locale)
	if (locale === "en") return en_oer_information_video_description_production40(inputs)
	if (locale === "fr") return fr_oer_information_video_description_production40(inputs)
	if (locale === "de") return de_oer_information_video_description_production40(inputs)
	if (locale === "es") return es_oer_information_video_description_production40(inputs)
	if (locale === "it") return it_oer_information_video_description_production40(inputs)
	return ar_oer_information_video_description_production40(inputs)
};
export { oer_information_video_description_production40 as "OER_INFORMATION_VIDEO_DESCRIPTION_PRODUCTION" }